import { Transition } from "@headlessui/react";
import {
    CheckCircleIcon,
    ExclamationIcon,
    InformationCircleIcon,
    QuestionMarkCircleIcon,
    XCircleIcon,
    XIcon
} from "@heroicons/react/solid";
import { Fragment, useState } from "react";

const ICONS = {
  blue: InformationCircleIcon,
  green: CheckCircleIcon,
  yellow: ExclamationIcon,
  red: XCircleIcon,
};

const Notification = ({ level, message, delay }) => {
  const [show, setShow] = useState(true);
  // useEffect(() => {
  //   setTimeout(() => {
  //     setShow(true);
  //   }, delay);
  // }, [delay]);

  const LevelIcon = ICONS[level] || QuestionMarkCircleIcon;

  return (
    <Transition
      appear
      show={show}
      as={Fragment}
      enter="ease-out duration-300 transition"
      enterFrom="translate-y-2 opacity-0 lg:translate-y-0 lg:translate-x-2"
      enterTo="translate-y-0 opacity-100 lg:translate-x-0"
      leave="transition ease-in duration-100"
      leaveFrom="opacity-100 lg:translate-x-0"
      leaveTo="opacity-0 lg:translate-y-0 lg:translate-x-2"
    >
      <div
        className={`max-w-sm w-full bg-${level}-50 bg-white shadow-lg rounded-lg pointer-events-auto overflow-hidden`}
      >
        <div className="p-4">
          <div className="flex items-start">
            <div className="shrink-0">
              <LevelIcon
                className={`h-6 w-6 text-${level}-400`}
                aria-hidden="true"
              />
            </div>
            <div className="ml-3 w-0 flex-1 pt-0.5">
              <p className="text-sm font-medium text-gray-900">{message}</p>
              {/* <p className="mt-1 text-sm text-gray-500">{message}</p> */}
            </div>
            <div className="ml-4 shrink-0 flex">
              <button
                className={`bg-white rounded-md inline-flex text-${level}-400 hover:text-${level}-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${level}-500`}
                onClick={() => {
                  setShow(false);
                }}
              >
                <span className="sr-only">Close</span>
                <XIcon className="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  );
};

export default Notification;
